const stripTags = (str) => str.replace(/<\/?[^>]+>/gi, '');

export { stripTags };
